import { createContext } from 'react';

const matchesContext = createContext();

export default matchesContext;